import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [心愿主页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=156943620
export const homepage = createAsyncThunk(
  'Saada/live/hiya_socialize/wish_form_homepage',
  async (p: {mid: number}, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/wish_form_homepage',
      {
        ...p,
      },
      {
        store,
      }
    )
    return resp.data
  }
)

// [心愿单设置配置] http://wiki.xunlei.cn/pages/viewpage.action?pageId=156943566
export const wishConfigs = createAsyncThunk(
  'Saada/live/hiya_socialize/wish_form_configs',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/wish_form_configs',
      {
        ...p,
      },
      {
        store,
      }
    )
    return resp.data
  }
)

// [心愿单心愿完成/助力记录] http://wiki.xunlei.cn/pages/viewpage.action?pageId=156943575
export const wish_form_records = createAsyncThunk(
  'Saada/live/hiya_socialize/wish_form_records',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/wish_form_records',
      {
        ...p,
      },
      {
        store,
      }
    )
    return resp.data
  }
)

// [心愿单分享] http://wiki.xunlei.cn/pages/viewpage.action?pageId=156943570
export const wish_form_share = createAsyncThunk(
  'Saada/live/hiya_socialize/wish_form_share',
  async (p: {mid: number; id: number}, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/wish_form_share',
      {
        ...p,
      },
      {
        store,
      }
    )
    return resp.data
  }
)

// [心愿单更新接口] http://wiki.xunlei.cn/pages/viewpage.action?pageId=156943256
export const wish_form_update = createAsyncThunk(
  'Saada/live/hiya_socialize/wish_form_update',
  async (
    p:
      | {
          mid: number
          type: 0
          gift_id: number
          gift_cnt: number
          rm_id: number
        }
      | {
          mid: number
          type: 1
          id?: number
        },
    store: any
  ) => {
    const resp = await http.post(
      '/live/hiya_socialize/wish_form_update',
      {
        ...p,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

export interface InitialStateType {
  homepage?: {
    is_male?: boolean
    list: {
      id: number
      gift_icon: string
      gift_cnt: number
      send_cnt: number
      mid: number
      mid_icon: string
      mid_name: string
      return_method: string
      status: number // 0 未完成，1 完成
      type: number // 0 女用户心愿单，1 男用户心愿单，2 空心愿单
      tip: string
      desc: string
      coin_ranges: number[]
    }[]
  }
  configs?: {
    gifts: {
      id: number
      icon: string
      coins: number
      name: string
    }[]
    gift_cnts: number[]
    return_methods: {id: number; desc: string}[]
  }
  records?: {
    is_male?: boolean
    more: boolean
    list: {
      id: number
      gift_icon: string // 图片地址
      gift_cnt: number // 礼物数量
      mid: number // 用户 ID
      mid_icon: string // 用户头像
      return_method: string // 回馈方式
      type: 0 | 1 // 0:心愿完成记录（女用户），1：助力成功记录（男用户视角）
    }[]
  }
}

const initialState: Partial<InitialStateType> = {}

export const SaadaWishSlice = createSlice({
  name: 'SaadaWish',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, {homepage: action.payload.data || {list: []}})
    })
    builder.addCase(wishConfigs.fulfilled, (state, action) => {
      Object.assign(state, {configs: action.payload.data || {}})
    })
    builder.addCase(wish_form_records.fulfilled, (state, action) => {
      Object.assign(state, {records: action.payload.data || {}})
    })
  },
})

export default SaadaWishSlice.reducer

export const useSaadaWishState = () => {
  const data = useSelector((state) => {
    return state.SaadaWish
  })
  return data
}
